/**
 * @flow
 *
 * The LoadingModal component acts as a simple loading overlay for use whilst waiting for
 * a remote task to complete.
 *
 * It is connected to Redux to determine whether it should be showing or not.
 */
import React from 'react';
import { ActivityIndicator, Modal, StyleSheet, View, Platform, StatusBar } from 'react-native';
import Theme from '../../theme';

/*
 * We use flow type to validate the Props of the component
 */
type Props = {
  // Whether the modal is visible
  loading: boolean,
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    backgroundColor: '#fff',
    borderRadius: 15,
    height: 150,
    justifyContent: 'center',
    width: 150,
  },
  overlay: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(204, 204, 204, 0.7)',
  },
});

const onRequestClose = () => {};

const renderLoading = (isLoading, style) => {
  return (
    <ActivityIndicator
      size="small"
      color={Theme.PRIMARY}
      animating={isLoading}
      style={[styles.activityIndicator, style]}
    />
  );
};

export default ({ isLoading, style }) => (
  renderLoading(isLoading, style)
);
